import React from 'react'

/**
 * Button semantics for the editor's icon controls, which are drawn as spans and divs: a button role, a place in the
 * Tab order, and Enter or Space pressing it as a click does. Spread onto the element; `onPress` replaces the click
 * for a control that acts on mouse down (so the text stays selected) rather than on click.
 */
export const pressable = (onPress?: () => void) => ({
  role: 'button' as const,
  tabIndex: 0,
  onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    if (onPress) onPress()
    else event.currentTarget.click()
  }
})
